export enum AccountType {
  ADMIN = 1,
  RESOURCE,
  B2C,
  COMPANY,
  DIRECT_RESOURCE,
  PERSON_KUSHKI,
  COMPANY_KUSHKI,
}
